import { EventCategory, EventSubCategory } from "@/types/events";
export const categorySubCategories = {
    [EventCategory.NIVEL_RIOS]: [
        EventSubCategory.BAIXO,
        EventSubCategory.ALTO,
        EventSubCategory.TRANSBORDANDO,
    ],
    [EventCategory.AREA_ALAGAMENTO]: [
        EventSubCategory.TRANSITAVEL,
        EventSubCategory.INTRANSITAVEL,
    ],
    [EventCategory.CHUVAS]: [
        EventSubCategory.CHUVA_FRACA,
        EventSubCategory.CHUVA_MODERADA,
        EventSubCategory.CHUVA_FORTE,
        EventSubCategory.ENXURRADA,
        EventSubCategory.DANOS_ESTRUTURA,
        EventSubCategory.PERDA_SOLO,
    ],
    [EventCategory.BARRAGENS]: [
        EventSubCategory.TRINCA,
        EventSubCategory.FISSURA,
        EventSubCategory.FUGA_AGUA,
        EventSubCategory.VAZAMENTO,
        EventSubCategory.CRESCIMENTO_VEGETACAO,
        EventSubCategory.OCUPACAO,
        EventSubCategory.CONSTRUCAO_IRREGULAR,
    ],
    [EventCategory.VENDAVAL]: [
        EventSubCategory.QUEDA_ARVORES,
        EventSubCategory.DANOS_REDE_ELETRICA,
        EventSubCategory.DANOS_RESIDENCIAS,
    ],
    [EventCategory.INCENDIO]: [
        EventSubCategory.RISCO_VIDA,
        EventSubCategory.PREJUIZO_MATERIAL,
        EventSubCategory.DEGRADACAO_AMBIENTAL,
        EventSubCategory.IMPACTOS_SAUDE_PUBLICA,
    ],
    [EventCategory.DESLIZAMENTO]: [
        EventSubCategory.DANOS_HUMANOS,
        EventSubCategory.DANOS_MATERIAIS,
        EventSubCategory.DANOS_AMBIENTAIS,
    ],
    [EventCategory.PRODUTOS_QUIMICOS]: [
        EventSubCategory.AGUA,
        EventSubCategory.AR,
        EventSubCategory.SOLO,
    ],
    [EventCategory.PERDA_SOLO]: [],
    [EventCategory.TREMOR]: [],
};
export const categoryHasSubcategories = (category) => !!category && categorySubCategories[category].length > 0;
